import { FormInstance, message } from "antd";

export async function ValidateForm(form: FormInstance) {
  try {
    await form.validateFields();
    return true;
  } catch (e: any) {
    if (e.errorFields.length > 0) {
      message.error("El formulario contiene errores");
      return false;
    } else {
      message.error("Error al validar el formulario");
      return false;
    }
  }
}
